import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../lib/api';
import { NotificationPreference, UpdatePreferencePayload } from './types';

export const notificationKeys = {
  all: ['notifications'] as const,
  preferences: () => [...notificationKeys.all, 'preferences'] as const,
};

// Get user's notification preferences
export function useNotificationPreferences() {
  return useQuery({
    queryKey: notificationKeys.preferences(),
    queryFn: async () => {
      const { data } = await api.get<{ preferences: NotificationPreference[] }>(
        '/customer/notifications/preferences'
      );
      return data.preferences;
    },
  });
}

// Update a notification preference
export function useUpdateNotificationPreference() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdatePreferencePayload) => {
      const { data } = await api.put('/customer/notifications/preferences', payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.preferences() });
    },
  });
}
